import { Button, Container, Dialog, IconButton, Paper, Stack, Typography, Box, Select, MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import {  toast } from '../../../../../utils';
import { BASE_URL } from '../../../../../utils/BaseUrl'

const initialRoleDataObj = {
  data: [],
  loading: false
};

export const PrintOption = () => {
  const [pageNumber, setPageNumber] = useState(1); // to handle the page number selection (dropdown 1-20)
  const [loading, setLoading] = useState(false);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);


  // Handle dropdown page number change
  const handlePageChange = (event) => {
    setPageNumber(event.target.value);
    console.log(`Page number selected: ${event.target.value}`);
  };

  const handleSave =  async () => {
    console.log(`Printing page ${pageNumber}`);
    try {
      const response=  await axios.post(`${BASE_URL}/printOptions`,{
            printOption: pageNumber
        });
        if(response.data.success){
        toast(`Print Option Changed Successfully `, { variant: 'success' });
        }else{
            toast(`Print Option Changed Feild `, { variant: 'error' });
        }
      } catch (error) {
        console.error('Error deleting user:', error);
        toast(`Something Went Wrong`, { variant: 'warning' });
      }
  };

  const handleGetPrintOption =  async () => {
    console.log(`Printing page ${pageNumber}`);
    try {
      const response=  await axios.get(`${BASE_URL}/printOptions`);
        if(response.data.success){
        setPageNumber(response?.data?.data?.printOption)
        }
      }catch (error) {
        console.error('Error deleting user:', error);
      }
  };

  useEffect(()=>{
    handleGetPrintOption()
  },[])

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container sx={{
          mt: 1,
          border: '0px solid',
          borderColor: 'grey.300',
          borderRadius: 1,
          width: '100%',
          maxWidth: 'none',
          minWidth: "100%",
          boxSizing: 'border-box',
        }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            sx={{ pb: 0.5, mb: 3, borderBottom: '1px solid', borderColor: 'grey.300' }}
          >
            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
              Print Option
            </Typography>
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
              <Select
                value={pageNumber}
                onChange={handlePageChange}
                displayEmpty
                variant="outlined"
                sx={{ minWidth: 120 }}
              >
                {[...Array(20).keys()].map(i => (
                  <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
                ))}
              </Select>

              <Button
                variant="contained"
                onClick={handleSave}
                disabled={loading}
              >
                Save
              </Button>
            </Stack>
          </Stack>
        </Container>
      </Paper>

      {/* Optional Query Dialog */}
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Print Preview
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        {/* Add content for print preview if necessary */}
      </Dialog>
    </>
  );
};
